export default {
  settings: 'Settings',
  general: 'General',
  organization: 'Organization',
  billing: 'Billing',
  aiIntegrations: 'AI integrations',
  aiIntegrationsTitle: 'AI integrations',
  aiIntegrationsDescription:
    'Connect external AI assistants to your Laplace context.',

  // General
  generalTitle: 'General',
  generalDescription: 'Manage your interface preferences.',
  profile: 'Profile',
  profileDescription: 'Update your display name and account email.',
  profileUpdated: 'Profile updated',
  profileUpdateFailed: 'Failed to update profile',
  name: 'Name',
  namePlaceholder: 'John Doe',
  nameRequired: 'Name is required.',
  nameTooLong: 'Name must be 120 characters or fewer.',
  email: 'Email',
  emailChangeHint:
    'We’ll send a confirmation link to the new email. Your current email works until you open it.',
  emailChangePending:
    'We sent a confirmation link to {{email}}. Your current email works until you open it.',
  emailChangeResend: 'Resend link',
  emailChangeCancel: 'Cancel change',
  emailChangeSent: 'Confirmation link sent',
  emailChangeCancelled: 'Email change cancelled',
  emailChangeInvalidEmail: 'Enter a valid email address.',
  emailChangeInUse: 'This email is already used by another account.',
  emailChangeUnchanged: 'This is already your email.',
  emailChangeSendFailed: 'We couldn’t send the email. Try again.',
  emailChangeFailed: 'Couldn’t start the email change. Try again.',
  passwordSecurity: 'Password',
  passwordSecurityDescription:
    'Change your account password after confirming your current password.',
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',
  passwordRules:
    'Password must be 8 to 50 characters and include uppercase and lowercase letters, a digit, and a special character.',
  passwordMinLength: 'Password must be at least 8 characters.',
  passwordTooLong: 'Password must be 50 characters or fewer.',
  passwordPolicy:
    'Password must be 8 to 50 characters and include uppercase and lowercase letters, a digit, and a special character.',
  passwordConfirmationMismatch: 'Passwords do not match.',
  currentPasswordInvalid: 'Current password is incorrect.',
  passwordReused: 'You cannot use your current or a recent password.',
  passwordChanged: 'Password changed',
  passwordChangeFailed: 'Failed to change password',
  passwordRateLimited: 'Too many attempts. Try again later.',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  language: 'Language',
  languageDescription: 'Select the language for the interface.',
  languageEn: 'English',
  languageRu: 'Русский',
  appearance: 'Appearance',
  appearanceDescription: 'Choose how the application looks.',
  themeLight: 'Light',
  themeLightDesc:
    'Standard light theme with full color contrast and brightness.',
  themeDark: 'Dark',
  themeDarkDesc:
    'Standard dark theme for comfortable work in low-light environments.',
  themeSystem: 'System',
  themeSystemDesc:
    'Automatically switches between light and dark themes based on your system settings.',
  codingIntegrations: 'Coding integrations',
  codingIntegrationsDescription:
    'Use your Laplace context in Codex, Claude Code, and other MCP clients.',
  mcpDescription:
    'A personal, read-only connection to the workspaces and chats you can access.',
  mcpLoading: 'Loading endpoint…',
  mcpCopy: 'Copy address',
  mcpCopied: 'Copied',
  mcpServerAddress: 'Connection address',
  mcpConnectedCount_one: '{{count}} connection',
  mcpConnectedCount_other: '{{count}} connections',
  mcpStepCopyTitle: 'Copy the address',
  mcpStepCopyDescription:
    'It works with Codex, Claude Code, and other clients.',
  mcpStepAddTitle: 'Add it to your AI assistant',
  mcpStepAddDescription:
    'Choose a remote MCP server and paste the Laplace address.',
  mcpStepApproveTitle: 'Approve access',
  mcpStepApproveDescription: 'Laplace will open and ask for your permission.',
  mcpReadOnlyNotice:
    'Read-only access to your context. Integration secrets are never shared.',
  mcpSetupHint:
    'Add this URL as a remote MCP server. Your coding agent will open Laplace to authorize access.',
  mcpConnectedClients: 'Connected clients',
  mcpConnectedClientsDescription:
    'AI assistants you have allowed to use your Laplace context.',
  mcpNoConnections: 'No connections yet',
  mcpNoConnectionsHint:
    'Your first client will appear here after you approve access.',
  mcpLastUsed: 'Last used: {{date}}',
  mcpNeverUsed: 'Not used yet',
  mcpRevoke: 'Revoke connection',
  mcpRevoked: 'Connection revoked',
  mcpRevokeFailed: 'Could not revoke connection',
  mcpLoadFailed: 'Could not load AI integrations',
  mcpRetry: 'Retry',
  mcpAuthorizeTitle: 'Connect {{client}}?',
  mcpAuthorizeDescription:
    'It will receive read-only access to the same Laplace data that you can access. Secrets and integration credentials are never shared.',
  mcpAuthorize: 'Authorize and continue',
  mcpDeny: 'Deny',
  mcpAuthorizationFailed: 'Could not complete authorization. Try again.',
  deleteAccount: 'Delete account',
  deleteAccountDescription: 'This action cannot be undone.',
  deleteAccountButton: 'Delete account',
  deleteAccountConfirmTitle: 'Delete account?',
  deleteAccountConfirmDescription: 'Your account will be permanently deleted.',
  deleteAccountConfirmInputLabel: 'Type your email to confirm deletion.',
  deleteAccountConfirmButton: 'Delete permanently',
  deleteAccountSuccess: 'Account deleted',
  deleteAccountFailed: 'Failed to delete account',
  adminSuccessionTitle: 'Workspace admin handoff required',
  adminSuccessionDescription:
    'You are the last admin in these workspaces. Choose a new admin.',
  adminSuccessionSelectAdmin: 'Choose a new admin',
  adminSuccessionNoCandidates: 'This workspace has no other members.',
  adminSuccessionWillDelete: 'Will be deleted',
  adminSuccessionSelectPlaceholder: 'New admin',
  adminSuccessionLoading: 'Checking workspaces...',
  adminSuccessionLoadFailed: 'Failed to check workspaces.',

  // Billing
  billingTitle: 'Billing',
  billingDescription:
    'Review your current subscription and manage plan changes.',
  loadingBilling: 'Loading billing details...',
}
